<div class="custom-mat-dialog-form" style="min-width: 40vw;">
  <div>
    <h3>{{data?.action}} Contact</h3>
  </div>
  <br />
  <div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (!isCreateAction) {
        <div class="row">
          <div class="col-sm-4 form-group">
            <br />
            <mat-label>
              <span>Contact</span><span class="orange-asterisk"> *</span>
            </mat-label>
          </div>
          <div class="col-sm-8 form-group">
            <ng-select [items]="availableContacts"
              [searchable]="true"
              [clearable]="false"
              bindLabel="ContactLabel"
              bindValue="ContactId"
              (change)="onContactChange($event)"
              formControlName="contact"
              required>
              <ng-template ng-option-tmp let-item="item">
                <span matTooltip="{{item.ContactLabel}}">{{item.ContactLabel}}</span>
              </ng-template>
            </ng-select>
            <br />
          </div>
        </div>
      }

      @if (this.form.get('contact')?.value || isCreateAction) {
        <div>
          <div class="row">
            <div class="col-sm-12 form-group">
              <!--Email Region-->
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Contact Name</mat-label>
                  <input matInput formControlName="contactName" required>
                </mat-form-field>
                @if (
                  form.get('contactName')?.invalid &&
                  (form.get('contactName')?.dirty ||
                  form.get('contactName')?.touched)) {
                  <p>
                    @if (form.get('contactName')?.hasError('required')) {
                      <mat-error>This field is required</mat-error>
                    }
                    @if (form.get('contactName')?.hasError('pattern')) {
                      <mat-error>
                        Enter valid Contact Name
                      </mat-error>
                    }
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 form-group">
              <!--Email Region-->
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Contact Email</mat-label>
                  <input matInput placeholder="pat@example.com" formControlName="contactEmail" required>
                </mat-form-field>
                @if (
                  form.get('contactEmail')?.invalid &&
                  (form.get('contactEmail')?.dirty ||
                  form.get('contactEmail')?.touched)) {
                  <p>
                    @if (form.get('contactEmail')?.hasError('required')) {
                      <mat-error>This field is required</mat-error>
                    }
                    @if (form.get('contactEmail')?.hasError('pattern')) {
                      <mat-error>
                        Enter valid Email
                      </mat-error>
                    }
                  </p>
                }
                @if (!(
                  form.get('contactEmail')?.invalid &&
                  (form.get('contactEmail')?.dirty ||
                  form.get('contactEmail')?.touched))) {
                  <p><br> </p>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group" style="display: flex; align-items: center;">
              <label class="col-lg-5 control-label">Contact Category<span class="orange-asterisk"> *</span></label>
              <div class="col-lg-7">
                <ng-select [items]="contactCategories"
                  bindLabel="description"
                  bindValue="id"
                  [searchable]="true"
                  [clearable]="false"
                  formControlName="contactCategory"
                  required>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="panel-body">
          @if (isCreateAction) {
            <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-grey ">
              <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
              Back
            </button>
          }
          @if (!isCreateAction) {
            <button (click)="deleteButtonHandler();$event.preventDefault()" mat-raised-button [disabled]="!this.form.get('contact')?.value" class="btn button-fix button-color-fix-red ">
              <mat-icon class=" icon-color-fix ">delete</mat-icon>
              Delete
            </button>
          }

          <button mat-raised-button type="submit" class="btn button-fix button-color-fix-orange pull-right" [disabled]="!form.valid">
            {{buttonLabel}}
            <mat-icon class=" icon-color-fix ">{{buttonIcon}}</mat-icon>
          </button>
        </div>
      </div>

      @if (!isCreateAction) {
        <div class="row">
          <div class="panel-body">
            <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-grey ">
              <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
              Back
            </button>
          </div>
        </div>
      }
    </form>
  </div>
</div>
